export const NAMES = {
  TAG: "ab-modal",
  CLASSES: {
    ROOT: "ab-modal",
    BACKDROP: "ab-modal__backdrop",
    WRAPPER: "ab-modal__wrapper",
    INNER: "ab-modal__inner",
    HEADER: "ab-modal__header",
    TITLE: "ab-modal__header-title",
    CLOSE: "ab-modal__close",
    CLOSE_ICON: "ab-modal__close-icon",
    CLOSE_TEXT: "ab-modal__close-text",
  },
}